export const get720FromCustomImage = (url: string) => url.replace('upload/', 'upload/c_fill,h_720,w_1280/')
export const get100FromCustomImage = (url: string) => url.replace('upload/', 'upload/c_fill,h_57,w_100/')